import { ApiHelper } from 'shared/helpers/api';
import { getUrl, ROUTES } from 'shared/api/urls';
import { getDomainConfig } from 'shared/domainConfig/helpers';
import { getMulticouponHeader } from 'shared/api/cart/helpers';

export enum DEVICE_TYPE {
  DESKTOP,
  MOBILE,
}

const API_DEVICE_TYPE = {
  [DEVICE_TYPE.DESKTOP]: 'WEBSITE',
  [DEVICE_TYPE.MOBILE]: 'MSITE',
};

const getDeviceType = (deviceType: DEVICE_TYPE) => API_DEVICE_TYPE[deviceType];

const DEFAULT_PAYLOAD: Record<string, string> = {
  fetchUniversalOffers: 'true',
  fetchCouponOffers: 'true',
  fetchPaymentMethodOffers: 'true',
  fetchTradeOffers: 'true',
};

interface IOffersApi {
  productId: string;
  isLoggedIn: boolean;
  deviceType: DEVICE_TYPE;
  isLoyalCustomer?: boolean;
  mrp?: string;
  sp?: string;
  isBestPriceEnabled: boolean;
  isMulticoupon?: boolean;
}

interface DomainConfig {
  [key: string]: string;
}

const DOMAIN_CONFIG: DomainConfig = {
  NYKAA_FASHION: 'fashion',
  FOOT_LOCKER: 'FOOT_LOCKER',
};

export const getProductOffers = ({
  productId,
  isLoggedIn,
  deviceType,
  isLoyalCustomer = true,
  mrp = '',
  sp = '',
  isBestPriceEnabled,
  isMulticoupon = false,
}: IOffersApi): Promise<any> => {
  const { API } = getDomainConfig();
  const isUserLoggedIn = isLoggedIn ? '1' : '0';
  const isLoyal = isLoyalCustomer ? '1' : '0';
  const device = getDeviceType(deviceType);

  const params = new URLSearchParams();
  params.append('customerGroupId', isUserLoggedIn);
  params.append('domain', DOMAIN_CONFIG[API.DOMAIN_PARAM]);
  params.append('deviceType', device);
  params.append('isLoyal', isLoyal);
  params.append('productId', productId);
  params.append('mrp', mrp);
  params.append('sp', sp);
  Object.keys(DEFAULT_PAYLOAD).map((item) => {
    params.append(item, DEFAULT_PAYLOAD[item]);
  });
  params.append('fetchBestOffers', isBestPriceEnabled.toString());

  const url = `${getUrl(ROUTES.PDP_OFFERS_V2)}?${params.toString()}`;
  const headers = getMulticouponHeader(isMulticoupon);

  return ApiHelper(url, { appendCSRFHeader: false, headers }).then((response: Response) => {
    if (response.ok === false) {
      return Promise.reject(response.statusText);
    }
    return response.json();
  });
};
